<main class="reference_form-main">
    <div class="main_container">
      <form [formGroup]="incidentRiskAreaForm">
      <div class="">
        <h3 class="form_name">Risk Areas</h3>


          <div class="input">
            <label for="">Risk Area Name</label>
            <input type="text" class="default_input reference-form" formControlName="RiskAreaName" />
            <label for="">Area Description</label>
            <input type="text" class="default_input reference-form" formControlName="RiskAreaDescription" />
            <!-- <label for="">Event Type</label> -->
            <!-- <select class="default_input reference-form" formControlName="IncidentEventTypeId" (change)="onSelectRiskArea($event.target.value)" #eventType style="width: 100%">
                <option value=""> Select Event Type </option>
                    <option *ngFor="let eventType of eventTypes"  [value]="eventType.id">
                     {{eventType.EventName}}
                    </option>
            </select> -->
               </div>


        <div class="btn_holder">
          <button class="default_primary-button" *ngIf="selectedIndex === null"
            (click)="addNew(incidentRiskAreaForm.value)">Add</button>
          <button class="default_primary-button" *ngIf="selectedIndex !== null"
            (click)="addNew(incidentRiskAreaForm.value)">Update</button>
          <button class="default_secondary-btn ml-2" (click)="onClearForm()">Reset</button>

        </div>

      </div>
    </form>
      <div class="display_table">
        <div class="search_container">
          <input type="text" class="default_input search"
          placeholder="Search for Incident Risk Areas"
          [formControl]="control"
          [appAutocomplete]="autocomplete"
          />
          <em class="ti-search"></em> 

          <app-autocomplete #autocomplete="appAutocomplete">
            <ng-template appAutocompleteContent>
              <ng-container
                *ngIf="(incidentRiskAreas | filterReference: control.value) as result"
              >
              <!-- [value]="option.IncidentEventTypeId" -->
                <app-option
                  (click)="selectIncidentRiskArea(option.id)"
                  *ngFor="let option of result"
                  [value]="option.RiskAreaName"
                  [value]="option.RiskAreaDescription"
                 
                >
                  {{ option. RiskAreaName}}
                  {{ option.RiskAreaDescription }}
                  <!-- {{ option.IncidentEventTypeId }} -->
                </app-option>
                <app-option class="no-result" *ngIf="!result.length"
                  >No result...</app-option
                >
              </ng-container>
            </ng-template>
          </app-autocomplete>
        </div>

        <div class="head" >
          <span class="item">S/N</span>
          <span class="item">Risk Area</span>
          <span class="item">Area Description</span>
          <!-- <span class="item">Event Type</span> -->
          <span class="item">Action</span>

        </div>

      <div class="scroll">

      </div>
      <div class="body_content" >
        <div class="the_body"
        *ngFor="let incidentRiskArea of incidentRiskAreaFormArray.get('IncidentRiskAreas')['controls']; index as i"
        (click)="onEdit(i, incidentRiskArea.value)" style="cursor: pointer;"
        matTooltip="Click to edit"
          aria-label="Button that displays a tooltip when focused or hovered over"
        >
          <span class="content">{{i + 1}}</span>
          <span class="content">{{incidentRiskArea.value.RiskAreaName}}</span>
          <span class="content">{{incidentRiskArea.value.RiskAreaDescription}}</span>
          <!-- <span class="content">{{getEventName(incidentRiskArea.value.IncidentEventTypeId)}}</span> -->
          <span class="content" (click)="$event.stopImmediatePropagation()">
            <button
            class="delete_icon trash"

            (click)="deleteIncidentRiskArea(i, incidentRiskArea.value)">
            <em class="ti-trash"> </em> </button>
          </span>

        </div>
        </div>
        <div class="btn_holder">
          <button class="default_primary-button" (click)="onSubmit(incidentRiskAreaFormArray.value)">Submit</button>
        </div>
      </div>
    </div>
  </main>

  <div class="box green_box"></div>
  <div class="box pink_box"></div>
